export const inputStyles = {
  marginRight: 2
};

export const healthBarContainer = {
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

export const snackbar = {
  marginBottom: 4
};

export const filterForm = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginY: 4
};

export const modalStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  '& p': {
    my: 1
  },
  '& button': {
    m: 1
  },
  '@media screen and (max-width: 600px)': {
    p: 2,
    minWidth: '22rem'
  }
};

export const upperActionsContainer = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  pr: 4,
  pl: 4,
  mb: 2,
  '@media screen and (max-width: 1000px)': {
    flexDirection: 'column',
    gap: 2
  }
};

export const selector = {
  container: {
    display: 'flex',
    maxHeight: 50
  },
  dropdown: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: { xs: 175, md: 200 },
    maxHeight: 50,
    background: '#FFF',
    width: 200,
    fontSize: '0.875rem',
    padding: '4px 8px',
    '& .MuiSelect-select': {
      padding: { xs: '4px 2px', md: '8px 12px' },
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: '100%'
    }
  },
  menuItem: {
    fontSize: { xs: '0.75rem', md: '0.875rem' },
    padding: '4px 8px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  menuItemContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  }
};
